import { useMediaQuery } from './useMediaQuery';

/**
 * Hook to detect mobile viewport (< 768px)
 * @returns {boolean} - True if viewport is mobile size
 */
export const useIsMobile = () => {
    return useMediaQuery('(max-width: 767px)');
};
